import { styled } from 'linaria/react';

export const MainProductBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
